'use client';

import { useState } from 'react';
import Slider, { Settings } from 'react-slick';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import AboutUsReviewsCarouselCard from './Card';

import './styles.css';

const settings: Settings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  dotsClass: 'carousel-dots',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        dots: true,
      },
    },
  ],
};

type Props = {
  usersReviews: {
    text: string;
    user: string;
    stars: string[];
  }[];
};

export default function AboutUsReviewsCarousel({ usersReviews }: Props) {
  const [sliderRef, setSliderRef] = useState<Slider | null>(null);

  return (
    <div className="w-[calc(100%-1.25rem)] mx-[0.625rem] md:w-[calc(100%-1.875rem)] md:mx-[0.9375rem] desktop:w-[calc(58.33333%-1.875rem)] desktop:ml-[calc(8.33333%+0.9375rem)] flex-[0_0_auto] relative">
      <button
        onClick={sliderRef?.slickPrev}
        className="w-11 h-[44px] bg-white rounded-full shadow-default absolute top-[50%] mt-[-50px] cursor-pointer translate-y-[-50%] outline-none z-10 desktop:translate-x-[-150%] desktop:translate-y-[-50%]">
        <FiChevronLeft className="w-6 h-6 text-gray-500 mx-auto" />
      </button>
      <button
        onClick={sliderRef?.slickNext}
        className="w-11 h-[44px] bg-white rounded-full shadow-default absolute top-[50%] right-0 mt-[-50px] cursor-pointer translate-y-[-50%] outline-none z-10 desktop:translate-x-[150%] desktop:translate-y-[-50%]">
        <FiChevronRight className="w-6 h-6 text-gray-500 mx-auto" />
      </button>
      <Slider ref={setSliderRef} className="mb-[30px]" {...settings}>
        {usersReviews.map((review, index) => (
          <AboutUsReviewsCarouselCard key={index} userReview={review} />
        ))}
      </Slider>
    </div>
  );
}
